<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button data-test="menuButton" auto-hide="false"></ion-menu-button>
        </ion-buttons>
        <ion-title data-test="title">Settings</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        
        @if (onDevice) {
  <ion-item data-test="channelsItem" detail="true" id="btnChannels" (click)="onChannelsClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Versions</span><br />
                <span class="line2">Use the Production, Beta or Alpha version.</span>
            </ion-label>
        </ion-item>
}
                
        <ion-item data-test="documentsItem" detail="true" id="btnDocuments" (click)="onDocumentsClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Documents</span><br />
                <span class="line2">Maintain Help, Marketing and Legal Documents.</span>
            </ion-label>
        </ion-item>

        <ion-item data-test="credentialsItem" detail="true" id="btnCredentials" (click)="onCacheCredsClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Cache Login Credentials</span><br />
                <span class="line2">This will make logging in easier.</span>
            </ion-label>
        </ion-item>
            
        <ion-item data-test="pricesItem" detail="true" id="btnPrices" (click)="onPricesClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Prices</span><br />
                <span class="line2">Maintain the message cost for the Pay As You Go package.</span>
            </ion-label>
        </ion-item>
            
        <ion-item data-test="skuActionsItem" detail="true" id="btnSkuActions" (click)="onSkuActionsClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Sku Actions</span><br />
                <span class="line2">Execute these actions when a sku is purchased.</span>
            </ion-label>
        </ion-item>

        <ion-item data-test="smsNumbersItem" detail="true" id="btnSmsNumbers" (click)="onSmsFromNumbersClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Sms From Numbers</span><br />
                <span class="line2">Maintain Sms Cell Numbers.</span>
            </ion-label>
        </ion-item>
        
        <ion-item data-test="importItem" detail="true" (click)="onImportClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Import</span><br />
                <span class="line2">Import json data into Firestore.</span>
            </ion-label>
        </ion-item>        
        
        <ion-item data-test="exportItem" detail="true" (click)="onExportClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Export</span><br />
                <span class="line2">Export Firestore data to Json. (Not Implemented Yet)</span>
            </ion-label>
        </ion-item>        
    </ion-list>
</ion-content>